module.exports = __webpack_public_path__ + "img/tire-transparent.8abd8a26.jpg";